export default "__VITE_ASSET__CQtavnOl__"